export const actionGroupTypes = {
    loading: "LOADING_ACTIONGROUP",
    delete: "DELETE_ACTIONGROUP",
    loadedOne: "LOADED_ACTIONGROUP",
    loadedMultiple: "LOADED_ACTIONGROUPS",
    success: "SUCCESS_ACTIONGROUP",
    restore: "RESTORE_ACTIONGROUP",
    hardDelete: "HARDDELETE_ACTIONGROUP",
};
